/* cart random number */

   var start = 16;
  var end = 30;
  var randomNum = randomNumber(start, end);

  $(".random-number-t").html(randomNum);

  function randomNumber(start, end) {
    var thisStart = parseInt(start);
    var thisEnd = parseInt(end);
    return Math.floor(Math.random() * (thisEnd - thisStart + 1) + thisStart);
  }


$(document).ready(function () {
  $(".rating-main").on("click", function (e) {
    // If parent with that ID is found → allow normal redirect
    if ($(this).closest("#Banner-template--24787768902018__image_banner").length) {
      return true; // do nothing, let it redirect
    }

    e.preventDefault(); // stop redirect

    $("html, body").animate(
      {
        scrollTop: $(".shopify-block.shopify-app-block").offset().top,
      },
      800
    );
  });

  $(".custom-feature-rating, .banner__text.banner__text-rating.rte.body , .ac-read-more").on("click", function (e) {
    // If parent with that ID is found → allow normal redirect
    if ($(this).closest("#Banner-template--24787768902018__image_banner").length) {
      return true; // do nothing, let it redirect
    }

    e.preventDefault(); // stop redirect

    $("html, body").animate(
      {
        scrollTop: $(".kl_reviews__list").offset().top,
      },
      800
    );
  });
});

/* image gallary slider */

$('.gallery-container').slick({
  speed: 8000,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: false,
  cssEase: 'linear',
  slidesToShow: 1,
  draggable: false,
  focusOnSelect: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  buttons: false,

  responsive: [
    {
      breakpoint: 768, // mobile breakpoint
      settings: {
        prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow gallery-item-arrow gallery-item-prev button button-primary" aria-label="Previous slide"><svg data-testid="svg-icon" focusable="false" role="img" class="svg-icon-arrow-primary-left" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow gallery-item-arrow gallery-item-next button button-primary" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
        autoplay: true,
        speed: 5000, // normal speed
        variableWidth: false,
        arrows: false,
        draggable: true,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    }
  ]
});